/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Input kind of a table cell. TEXT renders an auto-resizing textarea, NUMBER and INTEGER render a numeric input (INTEGER with step 1), DATE renders a date input storing an ISO-8601 date string (YYYY-MM-DD), CHECKBOX renders a checkbox.
 * @export
 */
export const InputType = {
    Text: 'TEXT',
    Number: 'NUMBER',
    Integer: 'INTEGER',
    Date: 'DATE',
    Checkbox: 'CHECKBOX'
} as const;
export type InputType = typeof InputType[keyof typeof InputType];


export function instanceOfInputType(value: any): boolean {
    for (const key in InputType) {
        if (Object.prototype.hasOwnProperty.call(InputType, key)) {
            if (InputType[key as keyof typeof InputType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InputTypeFromJSON(json: any): InputType {
    return InputTypeFromJSONTyped(json, false);
}

export function InputTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputType {
    return json as InputType;
}

export function InputTypeToJSON(value?: InputType | null): any {
    return value as any;
}

export function InputTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InputType {
    return value as InputType;
}

